import { ADD_ARTICLE, REFRESH_STEAMER_DRIFTER, SETTING_CHANGED, UPDATE_BET_MARKET, UPDATE_CONFIRM_BOX_STATUS, UPDATE_SHOW_FAVOURITE_OPTIONS, UPDATE_AI_RANK_STATS } from "../constants/action-types";
import { UPDATE_TIME_SETTINGS } from "../constants/action-types";
import { UPDATE_ALL_COUNTRY_LIST } from "../constants/action-types";
import { UPDATE_FILTERED_COUNTRY_LIST } from "../constants/action-types";
import { ADD_FILTERED_COUNTRY_LIST } from "../constants/action-types";
import { REMOVE_FILTERED_COUNTRY_LIST } from "../constants/action-types";
import { UPDATE_TIME_SETTINGS_ONE_BY_ONE } from "../constants/action-types";
import { UPDATE_BACK_STAKE_SETTINGS, UPDATE_DISPLAY_CONFIRM_NOX, UPDATE_LAY_STAKE_SETTINGS } from "../constants/action-types";
import {UPDATE_CURRENT_RACE_TIME} from "../constants/action-types";
import {UPDATE_TOKEN} from "../constants/action-types";
import {UPDATE_COMMISSION_SETTINGS} from "../constants/action-types";
import {UPDATE_T0_SETTINGS} from "../constants/action-types";
import {RUNNERS_ODDS_AT_TIMES} from "../constants/action-types";
import {IS_REFRESHED} from "../constants/action-types";
import {UPDATE_EXACT_TIME_SETTINGS_ONE_BY_ONE} from "../constants/action-types";
import {UPDATE_EXACT_TIME_SETTINGS} from "../constants/action-types";
import {UPDATE_IS_EXACT_TIME_SELECTED_ONE_BY_ONE} from "../constants/action-types";
import {UPDATE_STEAMER_DRIFTER_SETTINGS} from "../constants/action-types";
import {UPDATE_LOCAL_TIME_OFFSET_TO_GMT} from "../constants/action-types";
import {UPDATE_LOCAL_TIME_ZONE} from "../constants/action-types";
import {UPDATE_LATEST_ODDS_SETTINGS} from "../constants/action-types";
import {SET_CUSTOM_SETTINGS_STATE} from "../constants/action-types";

export function addArticle(payload){
  return {type: ADD_ARTICLE ,payload};
}
export function updateTimeSettings(payload){
  return {type: UPDATE_TIME_SETTINGS, payload};
}
export function updateExactTimeSettings(payload){
  return {type: UPDATE_EXACT_TIME_SETTINGS, payload};
}
export function updateAllCountryList(payload){
  return {type: UPDATE_ALL_COUNTRY_LIST, payload};
}
export function updateCommissionSetting(payload){
  return {type:UPDATE_COMMISSION_SETTINGS, payload}
}


export function updateBackStakeSetting(payload){
  return {type:UPDATE_BACK_STAKE_SETTINGS, payload}
}

export function updateLayStakeSetting(payload){
  return {type:UPDATE_LAY_STAKE_SETTINGS, payload}
}

export function updateLoginToken(payload){
  return {type: UPDATE_TOKEN, payload}
}

export function updateDisplayConfirmBox(payload){
  return {type: UPDATE_DISPLAY_CONFIRM_NOX, payload}
}

export function updateRefreshSteamerDrifter(payload){
  return {type: REFRESH_STEAMER_DRIFTER, payload}
}


export function updateShowFavouriteOption(payload){
  return {type: UPDATE_SHOW_FAVOURITE_OPTIONS, payload}
}

export function updateConfirmBoxStatus(payload){
  return {type: UPDATE_CONFIRM_BOX_STATUS, payload}
}
export function updateFilteredCountryList(payload){
  return {type: UPDATE_FILTERED_COUNTRY_LIST, payload};
}

export function updateSettingChanged(payload){
  return {type: SETTING_CHANGED, payload};
}

export function addToFilteredCountryList(payload){
  return {type: ADD_FILTERED_COUNTRY_LIST, payload};
}
export function removeFromFilteredCountryList(payload){
  return {type: REMOVE_FILTERED_COUNTRY_LIST, payload};
}
export function updateTimeSettingsOneByOne(payload){
  return {type: UPDATE_TIME_SETTINGS_ONE_BY_ONE, payload};
}
export function updateExactTimeSettingsOneByOne(payload){
  return {type: UPDATE_EXACT_TIME_SETTINGS_ONE_BY_ONE, payload};
}
export function updateCurrentRaceTime(payload){
  return {type: UPDATE_CURRENT_RACE_TIME, payload};
}
export function updateT0Settings(payload){
  return {type: UPDATE_T0_SETTINGS, payload};
}
export function updateRunnersOdds(payload){
  return {type: RUNNERS_ODDS_AT_TIMES, payload};
}
export function isRefreshed(payload){
  return {type: IS_REFRESHED, payload};
}
export function update_Is_Exact_Time_One_By_One(payload){
  return {type:UPDATE_IS_EXACT_TIME_SELECTED_ONE_BY_ONE, payload}
}

export function update_Steamer_Drifter_Settings(payload){
  return {type:UPDATE_STEAMER_DRIFTER_SETTINGS, payload}
}

export function updateLocalTimeOffSetToGmt(payload){
  return {type:UPDATE_LOCAL_TIME_OFFSET_TO_GMT, payload}
}

export function updateLocalTimeZone(payload){
  return {type:UPDATE_LOCAL_TIME_ZONE, payload}
}

export function updateLatestOddsSettings(payload){
  return {type:UPDATE_LATEST_ODDS_SETTINGS, payload}
}

export function setCustomSettingsState(payload){
  return {type:SET_CUSTOM_SETTINGS_STATE, payload}
}

export function updateBetMarket(payload){
  return {type:UPDATE_BET_MARKET, payload}
}

export function updateAiRankStats(payload){
  return {type:UPDATE_AI_RANK_STATS, payload}
}
